import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ViewVendorDashboardAction } from "../../../Redux/action/VendorDashboardAction";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { MdVerified } from "react-icons/md";
import { FormModel } from "../../Common/Modal/Modal";
import { ToastContainer, toast } from "react-toastify";
import axios from "axios";
import VideoModal from "../../Candidate/CandidateDashboard/VideoModal";
import { SpinLoader } from "../../Vendor/ImportCandidates";
import { Button, Modal, Form, Card, Table } from "react-bootstrap";
import { useRejectDocument } from "../../../Hooks/useRejectDocument";
import { FaExternalLinkAlt } from "react-icons/fa";
import imgFallLogo from "../../../images/company.png";
import imgFalldp from "../../../images/userimg.jpeg";
import Loader from "../../Common/Loader/loader";

const ViewVendor = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location?.search);
  const [loading, setLoading] = useState(false);
  const vendorId = queryParams.get("vendorId");
  const dispatch = useDispatch();

  const vendorDetails = useSelector(
    (state) => state?.VendorSideDashboard?.result
  );

  useEffect(() => {
    if (!vendorId) return;
    setLoading(true);
    dispatch(ViewVendorDashboardAction({ vendorId })).then((res) => {
      setLoading(false);
    });
  }, [dispatch, vendorId]);

  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    // Set initial width
    handleResize();
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  if (loading) {
    return (
      <div style={{ height: "70vh", display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Loader />
      </div>
    )
  }

  return (
    <div style={{ backgroundColor: "#f6f9ff", minHeight: "100vh" }}>
      <ToastContainer />
      <div style={{ padding: "1.5rem" }}>
        <h4 className="fw-bold mb-4">Vendor Details</h4>
        <div className="row">
          <div className="col-lg-4 mb-4">
            <Card className="h-100">
              <Card.Body className="d-flex flex-column align-items-center">
                <img
                  style={{ width: "100px", height: "100px" }}
                  src={
                    vendorDetails?.companyLogoUrl
                      ? vendorDetails?.companyLogoUrl
                      : imgFallLogo
                  }
                  className="rounded-circle mb-3 "
                  alt="Vendor Logo"
                />
                <h5>{vendorDetails?.company}</h5>
                <a
                  href={vendorDetails?.companyWebsite}
                  target="_blank"
                  className="d-block fs-6 small mb-3"
                >
                  {vendorDetails?.companyWebsite || "N/A"}
                </a>
                <Card style={{ width: "100%" }} className="mb-3 w-full">
                  <Card.Body className="text-start">
                    <h5>About</h5>
                    <h6 className="small fs-6 text-muted fw-normal">
                      {vendorDetails?.description || "N/A"}
                    </h6>
                  </Card.Body>
                </Card>
              </Card.Body>
              <div className="w-full mx-3">
                <h5 className="text-start">Profile Details</h5>
                <ul className="list-unstyled fs-6 text-start small">
                  <li className="d-flex justify-content-between">
                    <span className="text-start">Vendor ID:</span>{" "}
                    <span className="fw-bold text-end">
                      {vendorDetails?.vendorEmpId || "N/A"}
                    </span>
                  </li>
                  <li className="d-flex justify-content-between">
                    <span className="text-start">Verification:</span>{" "}
                    {vendorDetails?.isAccountVerified ? (
                      <span>
                        {" "}
                        <MdVerified color="green" />{" "}
                        <span
                          style={{
                            fontSize: "12px",
                            fontWeight: 600,
                            color: "green",
                          }}
                        >
                          VERIFIED VENDOR
                        </span>{" "}
                      </span>
                    ) : (
                      <span
                        style={{
                          border: "0.5px solid red",
                          borderRadius: "5px",
                          padding: "2px 5px",
                          fontSize: "10px",
                          backgroundColor: "red",
                          color: "white",
                        }}
                      >
                        NOT_VERIFIED
                      </span>
                    )}
                  </li>
                  <li className="d-flex justify-content-between">
                    <span className="text-start">Country:</span>{" "}
                    <span className="fw-bold text-end">{`${
                      (vendorDetails?.locations?.length > 0 &&
                        vendorDetails?.locations[0]?.country) ||
                      "N/A"
                    } `}</span>
                  </li>
                  <li className="d-flex justify-content-between">
                    <span className="text-start">State:</span>{" "}
                    <span className="fw-bold text-end">{`${
                      (vendorDetails?.locations?.length > 0 &&
                        vendorDetails?.locations[0]?.state) ||
                      "N/A"
                    } `}</span>
                  </li>
                </ul>
              </div>
            </Card>
          </div>
          <div className="col-lg-8">
            <Card className="mb-4">
              <Card.Body>
                <h5 className="fw-bold">Contact Information</h5>
                <div className="row d-flex justify-content-between align-item-center">
                  <div className="column col-md-7 pt-4">
                    <div className="d-flex justify-content-between">
                      <p className="mb-1 text-muted">Contact Person</p>
                      <p>{`${vendorDetails?.firstName || "N/A"} ${
                        vendorDetails?.lastName || ""
                      } `}</p>
                    </div>
                    <div className="d-flex gap-2 justify-content-between">
                      <p className="mb-1 text-muted">Email</p>
                      <p className="text-break">
                        {vendorDetails?.email || null}
                      </p>
                    </div>
                    <div className="d-flex justify-content-between">
                      <p className="mb-1 text-muted">Phone</p>
                      <p>
                        {vendorDetails?.dialCode && vendorDetails?.mobile
                          ? `+${vendorDetails.dialCode} ${vendorDetails.mobile}`
                          : ""}
                      </p>
                    </div>
                  </div>
                  <div className="col-md-3 text-center">
                    <img
                      style={{ maxWidth: "180px", maxHeight: "160px" }}
                      src={vendorDetails?.vendorProfileImageUrl ?? imgFalldp}
                      className="rounded-3"
                      alt="Vendor Logo"
                    />
                  </div>
                </div>
              </Card.Body>
            </Card>
            <ActionPage />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewVendor;

export const ActionPage = () => {
  const dispatch = useDispatch();
  const loader = useSelector((state) => state?.VendorSideDashboard?.loading);
  const vendorDetails = useSelector(
    (state) => state?.VendorSideDashboard?.result
  );
  const [showModel, setShowModel] = useState(false);
  const [showReject, setShowReject] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const queryParams = new URLSearchParams(location?.search);
  const vendorId = queryParams.get("vendorId");

  const handleCloseModal = () => {
    setShowModel(false);
    setSelectedImage(null);
    setSelectedImage1(null);
    setMsaFileInfo(null);
    setNdaFileInfo(null);
    setError1(null);
    setError2(null);
  };

  const handleCertificateModel = () => {
    setShowNSACertificates(false);
    setShowNDACertificates(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedImage || !selectedImage1) {
      return toast.warning("Please upload MSA & NDA Documents");
    }

    const cpyArray = [selectedImage, selectedImage1];

    const Size = cpyArray.reduce((acc, item) => acc + item?.size, 0);
    const filesize = Size / 1024 / 1024; // Convert to MB
    if (filesize > 1) {
      return toast.error("combine file size should be less than 1MB");
    }
    const formData = new FormData();
    formData.append("vendorId", vendorId);
    if (selectedImage) {
      formData.append("msa", selectedImage);
    }
    if (selectedImage1) {
      formData.append("nda", selectedImage1);
    }
    try {
      await axios
        .put(
          `${process.env.REACT_APP_API_PATH}/ebench/upload_msa_nda_doc`,
          formData
        )
        .then((data) => {
          if (data.data) {
            toast.success("Documents added sucessfully");
            setTimeout(() => {
              setShowModel(false);
              dispatch(ViewVendorDashboardAction({ vendorId }));
            }, 1000);
          }
        });
    } catch (err) {
      toast.error(err?.response?.data?.status?.message);
    }
  };

  const [showNDACertificates, setShowNDACertificates] = useState(false);
  const [showNSACertificates, setShowNSACertificates] = useState(false);
  const [showPANCertificates, setShowPANCertificates] = useState(false);
  const [showGSTCertificates, setShowGSTCertificates] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");
  const [selectedImage1, setSelectedImage1] = useState("");
  const [msaFileInfo, setMsaFileInfo] = useState(null);
  const [ndaFileInfo, setNdaFileInfo] = useState(null);
  const [error1, setError1] = useState("");
  const [error2, setError2] = useState("");
  const [verifyState, setVerifyState] = useState("");

  const handleFileChange = (e, setFileInfo, sendFileInfo, setError) => {
    const file = e.target.files[0];
    const filesize = file.size / 1024 / 1024;
    const allowedTypes = [
      "image/jpeg",
      "image/png",
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    ];
    if (allowedTypes.includes(file.type) && filesize < 1) {
      const preview = URL.createObjectURL(file);
      setFileInfo({ name: file.name, type: file.type.split("/")[0], preview });
      sendFileInfo(file);
      setError("");
    } else {
      setFileInfo(null);
      setError(
        "File must be an image, PDF, or DOC and size should be less than 1MB."
      );
      e.target.value = ""; // Reset the input
    }
  };

  const removeFile = (setFileInfo, inputFile) => {
    setFileInfo(null);
    document.getElementById(inputFile).value = null;
  };

  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const [isLoading, setIsLoading] = useState(true);
  const [ndaLoad, setNdaLoad] = useState(true);
  const handleLoad = () => {
    setIsLoading(false);
  };
  const handleVerification = async (verifyType) => {
    const baseUrl = process.env.REACT_APP_API_PATH;
    const formData = new FormData();
    if (verifyType === "Doc") {
      formData.append(
        "vendor",
        JSON.stringify({
          vendorId: vendorId,
          isDocumentVerified: true,
        })
      );
    } else if (verifyType === "Acc") {
      formData.append(
        "vendor",
        JSON.stringify({
          vendorId: vendorId,
          isAccountVerified: true,
        })
      );
    }
    try {
      const response = await axios.put(
        `${baseUrl}/ebench/update_vendor_v2`,
        formData
      );
      toast.success(
        `${
          verifyType === "Doc"
            ? "Document"
            : verifyType === "Acc"
            ? "Account"
            : ""
        } Verification Successfully`
      );
      verifyType === "Acc" ?? navigate(-1);
      handleClose();
    } catch (error) {}
  };

  const [checkboxes, setCheckboxes] = useState({
    nda: false,
    msa: false,
    pan: false,
  });

  const [rejectionReason, setReason] = useState("");
  const { mutate, isLoading: rejectLoding } = useRejectDocument();

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setCheckboxes((prev) => ({ ...prev, [name]: checked }));
  };

  const handleRejection = () => {
    if (!rejectionReason.trim()) {
      toast.error("Please enter a reason.");
      return;
    }
    // Build the documents array based on selected checkboxes
    const rejectedDocuments = [];
    if (checkboxes.nda) rejectedDocuments.push("NDA");
    if (checkboxes.msa) rejectedDocuments.push("MSA");
    if (checkboxes.pan) rejectedDocuments.push("PAN");
    mutate(
      { rejectedDocuments, rejectionReason, vendorId },
      {
        onSuccess: () => {
          handleClose2(); // Close the modal
        },
      }
    );
  };
  const [show, setShow] = useState(false);
  const handleClose = () => {
    setShow(false);
    setVerifyState("");
  };
  const handleShow = () => setShow(true);
  const handleClose2 = () => {
    setShowReject(false);
    setCheckboxes({
      nda: false,
      msa: false,
      pan: false,
    });
    setReason("");
  };
  const handleShow2 = () => setShowReject(true);
  useEffect(() => {
    dispatch(ViewVendorDashboardAction({ vendorId }));
  }, [show, showReject]);

  const getStatusBadge = (status) => {
    const color = status === "Verified" ? "success" : "warning";
    return <span className={`badge bg-${color}`}>{status}</span>;
  };

  return (
    <div style={{ width: "100%" }}>
      <ToastContainer />
      <Card>
        <Card.Body>
          <h5 className="fw-bold mb-3">Documents</h5>
          <Table bordered responsive>
            <thead>
              <tr>
                <th>Document Name</th>
                <th>Type</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {vendorDetails?.msadocUrl && (
                <tr>
                  <td>MSA Document</td>
                  <td>{vendorDetails?.msadocUrl?.split(".").pop()}</td>
                  <td>
                    {vendorDetails?.isDocumentVerified
                      ? getStatusBadge("Verified")
                      : getStatusBadge("Pending")}
                  </td>
                  <td>
                    {/* <FaDownload onClick={() => handleDownload(vendorDetails?.msadocUrl)} className="me-3" style={{ cursor: "pointer" }} /> */}
                    <FaExternalLinkAlt
                      onClick={() => [
                        setShowNSACertificates(true),
                        setNdaLoad(true),
                      ]}
                      style={{ cursor: "pointer" }}
                    />
                  </td>
                </tr>
              )}
              {vendorDetails?.ndadocUrl && (
                <tr>
                  <td>NDA Document</td>
                  <td>{vendorDetails?.ndadocUrl?.split(".").pop()}</td>
                  <td>
                    {vendorDetails?.isDocumentVerified
                      ? getStatusBadge("Verified")
                      : getStatusBadge("Pending")}
                  </td>
                  <td>
                    {/* <FaDownload onClick={() => handleDownload(vendorDetails?.ndadocUrl)} className="me-3" style={{ cursor: "pointer" }} /> */}
                    <FaExternalLinkAlt
                      onClick={() => [
                        setShowNDACertificates(true),
                        setIsLoading(true),
                      ]}
                      style={{ cursor: "pointer" }}
                    />
                  </td>
                </tr>
              )}
              {vendorDetails?.panImageUrl && (
                <tr>
                  <td>PAN Document</td>
                  <td>{vendorDetails?.panImageUrl?.split(".").pop()}</td>
                  <td>
                    {vendorDetails?.isDocumentVerified
                      ? getStatusBadge("Verified")
                      : getStatusBadge("Pending")}
                  </td>
                  <td>
                    {/* <FaDownload onClick={() => handleDownload(vendorDetails?.panImageUrl)} className="me-3" style={{ cursor: "pointer" }} /> */}
                    <FaExternalLinkAlt
                      onClick={() => [
                        setShowPANCertificates(true),
                        setIsLoading(true),
                      ]}
                      style={{ cursor: "pointer" }}
                    />
                  </td>
                </tr>
              )}
              {vendorDetails?.gstImageUrl && (
                <tr>
                  <td>GST Document</td>
                  <td>{vendorDetails?.gstImageUrl?.split(".").pop()}</td>
                  <td>
                    {vendorDetails?.isDocumentVerified
                      ? getStatusBadge("Verified")
                      : getStatusBadge("Pending")}
                  </td>
                  <td>
                    {/* <FaDownload onClick={() => handleDownload(vendorDetails?.gstImageUrl)} className="me-3" style={{ cursor: "pointer" }} /> */}
                    <FaExternalLinkAlt
                      onClick={() => [
                        setShowGSTCertificates(true),
                        setIsLoading(true),
                      ]}
                      style={{ cursor: "pointer" }}
                    />
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
          <div className="d-flex justify-content-end">
            {!vendorDetails?.isAccountVerified &&
              !vendorDetails?.isDocumentVerified &&
              vendorDetails?.isDocumentUploadLocked && (
                <Button
                  variant="outline-danger"
                  onClick={() => {
                    handleShow2();
                    setVerifyState("Doc");
                  }}
                  className="me-2"
                >
                  Reject Document
                </Button>
              )}
            {!vendorDetails?.isDocumentVerified &&
              vendorDetails?.ndadocUrl &&
              vendorDetails?.msadocUrl &&
              vendorDetails?.panImageUrl &&
              vendorDetails?.isDocumentUploadLocked && (
                <Button
                style={{width:"25%"}}
                  onClick={() => {
                    handleShow();
                    setVerifyState("Doc");
                  }}
                  className="btn-outline-primary-custom"
                >
                  Verify Document
                </Button>
              )}
            <div className="d-flex gap-2 justify-content-end">
              {!vendorDetails?.isAccountVerified &&
                vendorDetails?.isDocumentVerified &&
                vendorDetails?.isDocumentUploadLocked && (
                  <Button
                    onClick={() => {
                      handleShow();
                      setVerifyState("Acc");
                    }}
                    className="btn-outline-primary-custom"
                  >
                    Verify Account
                  </Button>
                )}
            </div>
          </div>
        </Card.Body>
      </Card>

      {showModel && (
        <FormModel
          style={{ zIndex: 999999999 }}
          isOpen={showModel}
          onClose={handleCloseModal}
        >
          <div>
            <p style={{ padding: "0px" }} className="common_table_header">
              Upload Documents
            </p>
            <hr />
            <form className="card-body" onSubmit={handleSubmit}>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                  flexDirection: width < 1000 ? "column" : "row",
                  gap: 20,
                }}
              >
                <div className={{ width: `50%`, border: "2px solid black" }}>
                  <label className="small mb-1" htmlFor="inputMsaFile">
                    MSA Document (Image, PDF, or DOC)
                  </label>
                  <input
                    type="file"
                    id="inputMsaFile"
                    className="form-control"
                    accept="image/*,application/pdf"
                    onChange={(e) =>
                      handleFileChange(
                        e,
                        setMsaFileInfo,
                        setSelectedImage,
                        setError1
                      )
                    }
                    required
                  />
                  {error1 && (
                    <div style={{ width: "20rem" }} className="text-danger">
                      {error1}
                    </div>
                  )}
                  {msaFileInfo && (
                    <div className="mt-2">
                      {msaFileInfo.type === "image" ? (
                        <div
                          style={{ width: width > 1023 ? "10rem" : "10rem" }}
                        >
                          <img
                            src={msaFileInfo.preview}
                            alt={msaFileInfo.name}
                            className="img-thumbnail"
                          />
                          <div className="my-3">
                            <button
                              type="button"
                              className="btn btn-sm btn-danger"
                              onClick={() =>
                                removeFile(setMsaFileInfo, "inputMsaFile")
                              }
                            >
                              Remove
                            </button>
                          </div>
                        </div>
                      ) : (
                        <div>
                          <div>
                            <p>
                              Uploaded {msaFileInfo.type.toUpperCase()}:{" "}
                              {msaFileInfo.name}
                            </p>
                          </div>
                          <div className="my-3">
                            <button
                              type="button"
                              className="btn btn-sm btn-danger"
                              onClick={() => removeFile(setMsaFileInfo)}
                            >
                              Remove
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>

                <div className={{ width: `50%` }}>
                  <label className="small mb-1" htmlFor="inputNdaFile">
                    NDA Document (Image, PDF, or DOC)
                  </label>
                  <input
                    type="file"
                    id="inputNdaFile"
                    className="form-control"
                    accept="image/*,application/pdf"
                    onChange={(e) =>
                      handleFileChange(
                        e,
                        setNdaFileInfo,
                        setSelectedImage1,
                        setError2
                      )
                    }
                    required
                  />
                  {error2 && (
                    <div style={{ width: "20rem" }} className="text-danger">
                      {error2}
                    </div>
                  )}
                  {ndaFileInfo && (
                    <div className="mt-2">
                      {ndaFileInfo.type === "image" ? (
                        <div
                          style={{ width: width > 1023 ? "10rem" : "10rem" }}
                        >
                          <img
                            src={ndaFileInfo.preview}
                            alt={ndaFileInfo.name}
                            className="img-thumbnail"
                          />
                          <div className="my-3">
                            <button
                              type="button"
                              className="btn btn-sm btn-danger"
                              onClick={() =>
                                removeFile(setNdaFileInfo, "inputNdaFile")
                              }
                            >
                              Remove
                            </button>
                          </div>
                        </div>
                      ) : (
                        <div>
                          <div>
                            <p>
                              Uploaded {ndaFileInfo.type.toUpperCase()}:{" "}
                              {ndaFileInfo.name}
                            </p>
                          </div>
                          <div className="my-3">
                            <button
                              type="button"
                              className="btn btn-sm btn-danger"
                              onClick={() => removeFile(setNdaFileInfo)}
                            >
                              Remove
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>

              <div
                style={{
                  marginTop: 20,
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <button className="nj_btn" type="submit">
                  {" "}
                  {loader ? "Uploading" : "Upload Documents"}{" "}
                </button>
              </div>
            </form>
          </div>
        </FormModel>
      )}
      {showNSACertificates && (
        <VideoModal
          showModal={showNSACertificates}
          handleClose={handleCertificateModel}
          title={`MSA Document`}
          newWindow={true}
          resumeUrl={vendorDetails?.msadocUrl}
          body={
            <div
              className="profile-video d-flex justify-content-center"
              style={{ margin: "0 auto", height: "80vh" }}
            >
              {ndaLoad && (
                <div style={{ display: "flex", alignItems: "center" }}>
                  {/* You can replace this with any loader component or animation */}
                  <p style={{ color: "blue" }}>
                    <SpinLoader />
                  </p>
                </div>
              )}
              {vendorDetails.msadocUrl ? (
                vendorDetails?.msadocUrl?.endsWith(".pdf") ? (
                  <iframe
                    src={vendorDetails?.msadocUrl}
                    title="Purchase Order PDF"
                    width="800rem"
                    height="100%"
                    onLoad={() => setNdaLoad(false)}
                    style={{ display: ndaLoad ? "none" : "block" }}
                  />
                ) : vendorDetails.msadocUrl?.endsWith(".doc") ||
                  vendorDetails.msadocUrl.endsWith(".docx") ? (
                  <iframe
                    src={`https://docs.google.com/gview?url=${vendorDetails?.msadocUrl}&embedded=true`}
                    title="MSA DOC"
                    width="800rem"
                    height="100%"
                    onLoad={() => setNdaLoad(false)}
                    style={{ display: ndaLoad ? "none" : "block" }}
                    frameBorder="0"
                  />
                ) : (
                  <img
                    style={{
                      display: ndaLoad ? "none" : "block",
                      objectFit: "contain",
                      width: "100%",
                      height: "100%",
                    }}
                    src={vendorDetails?.msadocUrl}
                    alt="Purchase Order"
                    onLoad={() => setNdaLoad(false)}
                  />
                )
              ) : (
                <p>No file available.</p> // Optional message for no file
              )}
            </div>
          }
        />
      )}
      {showNDACertificates && (
        <VideoModal
          showModal={showNDACertificates}
          handleClose={handleCertificateModel}
          title={`NDA Document`}
          newWindow={true}
          resumeUrl={vendorDetails?.ndadocUrl}
          body={
            <div
              className="profile-video d-flex justify-content-center"
              style={{ margin: "0 auto", height: "80vh" }}
            >
              {isLoading && (
                <div style={{ display: "flex", alignItems: "center" }}>
                  <p style={{ color: "blue" }}>
                    <SpinLoader />
                  </p>
                </div>
              )}

              {vendorDetails?.ndadocUrl ? (
                vendorDetails?.ndadocUrl?.endsWith(".pdf") ? (
                  <iframe
                    src={vendorDetails?.ndadocUrl}
                    title="Purchase Order PDF"
                    width="800rem"
                    height="100%"
                    onLoad={handleLoad} // Trigger handleLoad when the iframe content is loaded
                    style={{ display: isLoading ? "none" : "block" }} // Hide iframe initially until loaded
                  />
                ) : vendorDetails?.ndadocUrl?.endsWith(".doc") ||
                  vendorDetails?.ndadocUrl.endsWith(".docx") ? (
                  <iframe
                    src={`https://docs.google.com/gview?url=${vendorDetails?.ndadocUrl}&embedded=true`}
                    title="NDA DOC"
                    width="800rem"
                    height="100%"
                    frameBorder="0"
                    onLoad={handleLoad} // Trigger handleLoad when the iframe content is loaded
                    style={{ display: isLoading ? "none" : "block" }} // Hide iframe initially until loaded
                  />
                ) : (
                  <img
                    style={{
                      display: isLoading ? "none" : "block",
                      objectFit: "contain",
                      width: "100%",
                      height: "100%",
                    }}
                    src={vendorDetails?.ndadocUrl}
                    alt="NDA Docs"
                    onLoad={handleLoad} // Trigger handleLoad when the image content is loaded
                  />
                )
              ) : (
                <p>No file available.</p> // Optional message for no file
              )}
            </div>
          }
        />
      )}
      {showPANCertificates && (
        <VideoModal
          showModal={showPANCertificates}
          handleClose={() => setShowPANCertificates(false)}
          title={`Government Tax Document`}
          newWindow={true}
          resumeUrl={vendorDetails?.panImageUrl}
          body={
            <div
              className="profile-video d-flex justify-content-center"
              style={{ margin: "0 auto", height: "80vh" }}
            >
              {isLoading && (
                <div style={{ display: "flex", alignItems: "center" }}>
                  <p style={{ color: "blue" }}>
                    <SpinLoader />
                  </p>
                </div>
              )}
              {vendorDetails?.panImageUrl ? (
                vendorDetails?.panImageUrl?.endsWith(".pdf") ? (
                  <iframe
                    src={vendorDetails?.panImageUrl}
                    title="Purchase Order PDF"
                    width="800rem"
                    height="100%"
                    onLoad={handleLoad} // Trigger handleLoad when the iframe content is loaded
                    style={{ display: isLoading ? "none" : "block" }} // Hide iframe initially until loaded
                  />
                ) : vendorDetails?.panImageUrl?.endsWith(".doc") ||
                  vendorDetails?.panImageUrl.endsWith(".docx") ? (
                  <iframe
                    src={`https://docs.google.com/gview?url=${vendorDetails?.panImageUrl}&embedded=true`}
                    title="NDA DOC"
                    width="800rem"
                    height="100%"
                    frameBorder="0"
                    onLoad={handleLoad} // Trigger handleLoad when the iframe content is loaded
                    style={{ display: isLoading ? "none" : "block" }} // Hide iframe initially until loaded
                  />
                ) : (
                  <img
                    style={{
                      display: isLoading ? "none" : "block",
                      objectFit: "contain",
                      width: "100%",
                      height: "100%",
                    }}
                    src={vendorDetails?.panImageUrl}
                    alt="NDA Docs"
                    onLoad={handleLoad} // Trigger handleLoad when the image content is loaded
                  />
                )
              ) : (
                <p>No file available.</p> // Optional message for no file
              )}
            </div>
          }
        />
      )}
      {showGSTCertificates && (
        <VideoModal
          showModal={showGSTCertificates}
          handleClose={() => setShowGSTCertificates(false)}
          title={`GST Document`}
          newWindow={true}
          resumeUrl={vendorDetails?.gstImageUrl}
          body={
            <div
              className="profile-video d-flex justify-content-center"
              style={{ margin: "0 auto", height: "80vh" }}
            >
              {isLoading && (
                <div style={{ display: "flex", alignItems: "center" }}>
                  <p style={{ color: "blue" }}>
                    <SpinLoader />
                  </p>
                </div>
              )}
              {vendorDetails?.gstImageUrl ? (
                vendorDetails?.gstImageUrl?.endsWith(".pdf") ? (
                  <iframe
                    src={vendorDetails?.gstImageUrl}
                    title="Purchase Order PDF"
                    width="800rem"
                    height="100%"
                    onLoad={handleLoad} // Trigger handleLoad when the iframe content is loaded
                    style={{ display: isLoading ? "none" : "block" }} // Hide iframe initially until loaded
                  />
                ) : vendorDetails?.gstImageUrl?.endsWith(".doc") ||
                  vendorDetails?.gstImageUrl.endsWith(".docx") ? (
                  <iframe
                    src={`https://docs.google.com/gview?url=${vendorDetails?.gstImageUrl}&embedded=true`}
                    title="NDA DOC"
                    width="800rem"
                    height="100%"
                    frameBorder="0"
                    onLoad={handleLoad} // Trigger handleLoad when the iframe content is loaded
                    style={{ display: isLoading ? "none" : "block" }} // Hide iframe initially until loaded
                  />
                ) : (
                  <img
                    style={{
                      display: isLoading ? "none" : "block",
                      objectFit: "contain",
                      width: "100%",
                      height: "100%",
                    }}
                    src={vendorDetails?.gstImageUrl}
                    alt="NDA Docs"
                    onLoad={handleLoad} // Trigger handleLoad when the image content is loaded
                  />
                )
              ) : (
                <p>No file available.</p> // Optional message for no file
              )}
            </div>
          }
        />
      )}
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        style={{ top: "30%" }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Verification</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Do you want to verify this vendor's{" "}
          {verifyState === "Doc" ? "documents" : "Account"}?
        </Modal.Body>
        <Modal.Footer
          className="flex-center"
          style={{ justifyContent: "center" }}
        >
          <Button
            className="btn-primary-custom"
            onClick={() => handleVerification(verifyState)}
          >
            Submit
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showReject}
        onHide={handleClose2}
        backdrop="static"
        keyboard={false}
        style={{ top: "15%" }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Reject </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Check
              type="checkbox"
              label="NDA Document"
              name="nda"
              checked={checkboxes.nda}
              onChange={handleCheckboxChange}
            />
            <Form.Check
              type="checkbox"
              label="MSA Document"
              name="msa"
              checked={checkboxes.msa}
              onChange={handleCheckboxChange}
            />
            <Form.Check
              type="checkbox"
              label="PAN Document"
              name="pan"
              checked={checkboxes.pan}
              onChange={handleCheckboxChange}
            />
            <Form.Group className="mt-3">
              <Form.Label>
                Reason for rejection <span style={{ color: "red" }}>*</span>
              </Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                maxLength={50}
                value={rejectionReason}
                onChange={(e) => setReason(e.target.value)}
                required
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer
          className="flex-center"
          style={{ justifyContent: "center" }}
        >
          <Button
            className="btn-primary-custom"
            disabled={rejectLoding}
            onClick={handleRejection}
          >
            {rejectLoding ? "Loading..." : "Submit"}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
